import { executeRequest, Request } from '@jfs/network'
import { ReportTypeEnum } from '../../src/data/models/Settlements'
import { APIEndPoints } from './APIEndpoints'
import { sitConfig } from './config'

const responseParser = (data: any) => {
  return data
}

const deleteSettlementReportFormatReq = (id: string, mid: string, tokens: any) => {
  const request: Request<{}> = {
    apiPath: APIEndPoints.deleteSettlementReportFormat,
    method: 'POST',
    config: sitConfig(tokens),
    // headers: {
    //   'Content-Type': 'application/json',
    //   Authorization: userAccessToken,
    // },
    body: {
      inputFilter: {
        merchantId: mid,
        requestId: id,
        reportType: ReportTypeEnum.SETTLEMENT,
      },
    },
  }
  return executeRequest(request).then((data) => {
    return responseParser(data.data)
  })
}

export { deleteSettlementReportFormatReq }
